import type { FrontendWidget } from '../../types';
import { RichTextBlockComponent } from './RichTextBlockComponent';
import type { RichTextBlockConfig, RichTextBlockResolved } from './types';

export const richTextBlockWidget: FrontendWidget<
  RichTextBlockConfig,
  RichTextBlockResolved
> = {
  componentType: 'content-blocks.rich-text',
  displayName: 'Rich Text',
  defaultValues: { alignment: 'left', width: 'narrow', body: [] },
  ComponentA: RichTextBlockComponent,
  resolveSync: (config) => config,
};
